<template>
  <div class="locale-switcher">
    <select class="white--text px-2" dark v-model="$i18n.locale">
      <option class="black--text px-2" :value="locale.code" v-for="locale in locales" :key="locale.code">
        {{locale.name}}
      </option>
    </select>
  </div>
</template>

<script>
import { getSupportedLocales } from "@/i18n/supported-locales.js"

export default {
  name: "LanguageSelector",
  data: () => ({
    locales: getSupportedLocales(),
    languages: [
      {
        flag: "../assets/flags/en.png",
        code: "EN",
        name: "English",
        locale: "en",
      },
      {
        flag: "../assets/flags/cy.png",
        code: "CY",
        name: "Welsh",
        locale: "cy",
      },
      {
        flag: "../assets/flags/fr.png",
        code: "FR",
        name: "French",
        locale: "fr",
      },
    ],
  }),
};
</script>
